import { FormattedNumber } from '@billy/design-system'

import { DEFAULT_CURRENCY } from '@features/invoices/constants/defaultCurrency'
import { useUserOrganization } from '@modules-deprecated/app/organization'

import { Currency } from '../../../../types/currency'
import { getCurrentLocale } from '../../../../utils'
import { DEFAULT_CURRENCY_NUMBER_FORMAT_OPTIONS } from '../../constants/defaultCurrencyNumberFormatOptions'

interface SalesReportTableFormattedCurrencyProps {
  value: number
}

export const SalesReportTableFormattedCurrency = ({ value }: SalesReportTableFormattedCurrencyProps) => {
  const { organization } = useUserOrganization()
  const locale = getCurrentLocale()
  const currency = (organization?.baseCurrencyId ?? DEFAULT_CURRENCY) as Currency

  return (
    <FormattedNumber.Currency
      currency={currency}
      locale={locale}
      options={DEFAULT_CURRENCY_NUMBER_FORMAT_OPTIONS}
      value={value}
    />
  )
}
